console.log("Tabletop Goodies - Script - HTTP");

TTG = function (parent) {
    const result = {};


    result.getQueryStringValue = function (name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    };

    parent.Http = result;
    return parent;
}(TTG);

if (!TTG.isEmptyOrWhiteSpaces(TTG.Http.getQueryStringValue("debug"))) {
    TTG.Context.debugMode = true;
}

const languageId = TTG.Http.getQueryStringValue("language");

if (!TTG.isEmptyOrWhiteSpaces(languageId)) {
    TTG.Context.currentLanguageId = languageId;
}
